import React, { FC, useEffect } from "react";
// import MindMeLogo from "../../../../images/logos/mindme-logo.png";
import {
  FlexContainer,
  IOption,
  SingleSelect,
} from "@mindmemobile/mm-shared-global";
import { AuthService } from "../shared/services";
// import { Topbar } from "../shared/styles";

type IData = {
  label: string;
  value: string;
};

const stagingData: IData[] = [
  {
    label: "Testing Use Only",
    value: "65cb465ddb04cbbba41c9079",
  },
  {
    label: "Freedom Yoga",
    value: "671789e4e18aee98115654f9",
  },
  {
    label: "The Pizza Shack",
    value: "67178a07e18aee98115654fa",
  },
  {
    label: "Plumbing Pros",
    value: "67178a1ae18aee98115654fb",
  },
  {
    label: "Save the Planet",
    value: "67178a4ce18aee98115654fc",
  },
  {
    label: "Education Station",
    value: "67178a5be18aee98115654fd",
  },
  {
    label: "Jagjit Singh",
    value: "672b0173df69fb17fc83950e",
  },
];

let data: IData[] = [];

const productionData: IData[] = [
  {
    label: "Testing Use Only",
    value: "65cb465ddb04cbbba41c9079",
  },
];

const HeaderBarMain: FC = ({}) => {
  data = process.env.REACT_APP_IsLive === "true" ? productionData : stagingData;

  function onChange(value: string) {
    AuthService.setAuthData(value);
    window.location.href = "/";
  }
  const singleSelect = (
    selectedKey: string,
    className: string,
    options: IOption[]
  ): React.ReactNode => {
    return (
      <SingleSelect
        selectedKey={selectedKey}
        searchable={false}
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[options || []]}
        onChange={(option: any) => onChange(option.value)}
        className={className}
      />
    );
  };

  return (
    <>
      <FlexContainer
        alignItems="center"
        justifyContent="space-between"
        padding="0px 20px"
        style={{ height: "112px" }}
      >
        <img src={""} height={"61px"} style={{ padding: "10px" }} />
        {singleSelect(AuthService.authData.accountId, "", data)}
      </FlexContainer>
      {/* 
      <Topbar>
        <div>Money</div>
      </Topbar> */}
    </>
  );
};
export default HeaderBarMain;
